import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=2ca7907f&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=2ca7907f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7907f",
  null
  
)

export default component.exports